import { render, staticRenderFns } from "./Web.vue?vue&type=template&id=06092a05"
import script from "./Web.vue?vue&type=script&lang=js"
export * from "./Web.vue?vue&type=script&lang=js"
import style0 from "./Web.vue?vue&type=style&index=0&id=06092a05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports